<template>
  <div class="AppointmentList CommonContentSingle-gray">
    <el-container>
      <el-header style="background: rgba(255, 255, 255, 1);min-height: 80px;height: auto;">
        <el-form :model="ruleForm" ref="ruleForm" :inline="true" class="demo-form-inline"
          style="margin: 20px 0px;background: rgba(245, 247, 250, 1);padding: 10px;overflow: hidden;height: 42px;">
          <el-form-item label="咨询师">
            <el-input placeholder="咨询师姓名/账号" v-model="ruleForm.ConsulName" style="width:150px;">
            </el-input>
          </el-form-item>
          <el-form-item label="学生姓名">
            <el-input :placeholder="'学生姓名/' + $t('original.account')" v-model="ruleForm.StudentName"
              style="width:150px;"></el-input>
          </el-form-item>
          <el-form-item label="当前状态">
            <el-form-item label="" prop="EntryDate">
              <el-select v-model="ruleForm.State" placeholder="请选择状态">
                <el-option label="未评估" value="0"></el-option>
                <el-option label="已评估" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-button type="primary" style="margin-bottom: 20px;margin-left:50px;" @click="PeopleSetting()">
            学生分配
          </el-button>
          <el-button type="primary" @click="resetForm()" style="margin-top: 5px; margin-left: 10px;">重置</el-button>
          <el-button type="primary" @click="onSelect()">查询</el-button>
        </el-form>
      </el-header>
      <el-main style="margin-top: 15px; background: rgba(255, 255, 255, 1);">
        <el-table class="Page" :data="AppointList" style="width: 100%;" v-loading="IsLoading"
          element-loading-background="rgba(255,255,255,1)" element-loading-text="数据正在加载中"
          element-loading-spinner="el-icon-loading">
          <el-table-column label="序号" min-width="5%">
            <template slot-scope="scope">
              {{ (pageIndex - 1) * 10 + scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="UserID" :label="$t('original.account')" min-width="10%"></el-table-column>
          <el-table-column prop="StudentName" label="学生姓名" min-width="10%"></el-table-column>
          <el-table-column prop="Specialty" label="专业" min-width="10%"></el-table-column>
          <el-table-column prop="DeptName" label="学院" min-width="20%"></el-table-column>
          <el-table-column prop="ConsultID" label="咨询师账号" min-width="10%"></el-table-column>
          <el-table-column prop="ConsulName" label="咨询师姓名" min-width="10%"></el-table-column>
          <el-table-column label="评估状态" min-width="8%">
            <template slot-scope="scope">
              <div style="color:red;" v-if="scope.row.State == 0">
                {{ scope.row.EvalState }}
              </div>
              <div style="color:blue;" v-else>{{ scope.row.EvalState }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="CreatedDate" label="分配时间" min-width="10%"></el-table-column>
          <el-table-column label="操作" min-width="6%" align="center">
            <template slot-scope="scope">
              <span class="table_btn" @click="DeleteRow(scope.row)">
                删除
              </span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="AppointList.length > 0">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="pageIndex" :page-size="10" layout="total, prev, pager, next" :total="Counts">
          </el-pagination>
        </div>
      </el-main>
    </el-container>

    <el-dialog :visible.sync="WPPdialogVisible3" width="70%" :close-on-click-modal="false"
      :close-on-press-escape="false" :before-close="handleClose">
      <div class="dialog-content" :style="{ height: dialogHeight }">
        <div class="grid-content bg-purple-left">
          <div class="bg-purple-option">
            <span>咨询师搜索：</span>
            <el-input v-model="from.TeacherVal" placeholder="请输入内容" style="width:50%;"></el-input>
            <el-button type="primary" style="margin-left: 20px;" @click="onTeacherSearch()">
              搜索
            </el-button>
          </div>
          <el-radio-group v-model="regionType">
            <el-radio v-for="item in regionTypes" style="margin:25px 15px;" :label="item.UserID" :key="item.UserID">
              {{ item.RealName }}</el-radio>
          </el-radio-group>
        </div>
        <div class="grid-content bg-purple-right">
          <div class="bg-purple-option">
            <span style="margin-left: 20px;">学生搜索：</span>
            <el-input v-model="from.StudentVal" :placeholder="
              '请输入' + $t('original.account') + '、姓名、专业或学院'
            " style="width:50%;"></el-input>
            <el-button type="primary" style="margin-left: 20px;" @click="onStudentSearch()">
              搜索
            </el-button>
            <el-button type="primary" style="margin-left: 20px;" @click="onClearData()">
              重置
            </el-button>
          </div>
          <div class="bg-purple-content">
            <el-table ref="studentTable" :data="riRateContent" style="width: 100%;">
              <el-table-column type="selection" min-width="10%" style="width:65px">
              </el-table-column>
              <el-table-column label="序号" min-width="10%">
                <template slot-scope="scope" center>
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column prop="UserID" :label="$t('original.account')" min-width="15%">
              </el-table-column>
              <el-table-column prop="RealName" label="姓名" min-width="15%">
              </el-table-column>
              <el-table-column prop="Specialty" label="专业" min-width="25%">
              </el-table-column>
              <el-table-column prop="DeptName" label="学院" min-width="40%">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="buttons">
          <el-button @click="WPPdialogVisible3 = false">取消</el-button>
          <el-button type="primary" @click="Addlist()">
            确认添加
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  data() {
    return {
      dialogHeight: '500px',
      AppointList: [],
      regionType: '',
      regionTypes: [],

      riRate: [],
      riRateContent: [],

      from: {
        TeacherVal: '',
        StudentVal: '',
      },
      filterObj: [],
      wonedata: '',
      wonedata2: '',
      WPPdialogVisible3: false,
      showViewDetails: false,
      Counts: 1,
      pageSize: 10,
      pageIndex: 0,
      detailsdata: '',
      ruleForm: {
        ConsulName: '',
        ConsulAccount: '',
        StudentName: '',
        StudentAccount: '',
        State: '',
      },
      dialogVisible: false,
      IsLoading: false,
      IsDialogLoading: false,
    };
  },
  created() {
    this.Init();
  },
  methods: {
    handleSizeChange(val) { },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.Init(val);
    },
    Addlist() {
      if (this.regionType == '') {
        this.$message({
          message: '请选择老师',
          type: 'warning',
        });
        return;
      }
      this.riRate = this.$refs.studentTable.selection;
      if (this.riRate.length == 0) {
        this.$message({
          message: '请至少选择一个学生',
          type: 'warning',
        });
        return;
      }
      let _this = this;
      this.$Http_Post('ConsultAppoint/AddReportDataList', {
        zixunshi: _this.regionType, //来访者
        xuesheng: _this.riRate,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          _this.Init();
          _this.WPPdialogVisible3 = false;
          _this.regionType = '';
          _this.riRate = [];
        } else this.Global.request_failure(res.Message);
      });
    },
    WPPdialogClose() {
      this.$confirm('确认关闭？')
        .then((_) => {
          this.WPPdialogVisible = false;
        })
        .catch((_) => { });
    },
    Fillin(row, event) {
      this.from.AppointmentID = event.AppointmentID;
      this.from.UserID = event.UserID;
      this.from.Counselor = event.Counselor;
      this.WPPdialogVisible = true;
    },
    wlooks(row, event) {
      this.from.AppointmentID = event.AppointmentID;
      this.wonedata = event;
      this.WPPdialogVisible2 = true;
      var xcscs = {
        AppointmentID: event.AppointmentID,
      };
      this.$Http_Post('ConsultSubscribe/FxConsultAnswer', { from: xcscs }).then(
        (res) => {
          this.$message.closeAll();
          if (res.Code == 200 || res.Code == 0) {
            this.wonedata2 = res.Data;
          } else {
          }
        }
      );
    },
    dialogV() {
      this.$confirm('保存后数据无法修改，您能确定保存吗 ?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$Http_Post('ConsultSubscribe/AddConsultAnswer', {
            from: this.from,
          }).then((res) => {
            this.$message.closeAll();
            if (res.Code == 200 || res.Code == 0) {
              this.WPPdialogVisible2 = false;
              this.WPPdialogVisible = false;
              this.Global.request_successful(res.Message);
              this.Init();
            } else {
              this.WPPdialogVisible2 = false;
              this.WPPdialogVisible = false;
              this.Global.request_failure(res.Message);
            }
          });
        })
        .catch(() => { });
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    ViewDetails(row) {
      this.showViewDetails = true;
      var csccvsd = {
        AppointmentID: row.AppointmentID,
      };
      this.$Http_Post('ConsultAppoint/GetappointmentDetails', {
        from: csccvsd,
      }).then((res) => {
        this.$message.closeAll();
        if (res.Code == 200 || res.Code == 0) {
          this.detailsdata = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    resetForm() {
      this.ruleForm.ConsulName = '';
      this.ruleForm.StudentName = '';
      this.ruleForm.State = '';
      this.pageIndex = 1;
      this.Init();
    },
    onTeacherSearch() {
      if (this.from.TeacherVal == '') {
        this.$message({
          message: '您未输入咨询师查询条件',
          type: 'warning',
        });
      } else {
        this.$Http_Post('ConsultAppoint/GetTeacherSearch', this.from, {}).then(
          (res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.regionTypes = res.Data;
            } else {
              this.$message.error(res.Message);
            }
          }
        );
      }
    },

    onStudentSearch() {
      if (this.from.StudentVal == '') {
        this.$message({
          message: '您未输入学生查询条件',
          type: 'warning',
        });
      } else {
        this.$Http_Post('ConsultAppoint/GetStudentSearch', this.from, {}).then(
          (res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.riRateContent = res.Data;
            } else {
              this.$message.error(res.Message);
            }
          }
        );
      }
    },

    onSelect() {
      if (
        this.ruleForm.ConsulName == '' &&
        this.ruleForm.StudentName == '' &&
        this.ruleForm.State == ''
      ) {
        this.$message({
          message: '您未输入查询条件',
          type: 'warning',
        });
      } else {
        this.pageIndex = 1;
        this.currentPage1 = 1;
        let _this = this;
        if (!_this.filterObj.filterTag) {
          _this.filterObj.filterTag = [];
        }
        this.$Http_Post('ConsultAppoint/GetUserSetting', {
          ConsulName: _this.ruleForm.ConsulName,
          StudentName: _this.ruleForm.StudentName,
          State: _this.ruleForm.State,
          pageIndex: _this.pageIndex,
          pageSize: 10,
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            _this.AppointList = res.Data;
            this.Counts = Number(res.Counts);
          } else {
            this.$message.error(res.Message);
          }
        });
      }
    },
    Init() {
      this.IsLoading = true;
      let _this = this;
      this.$Http_Post('ConsultAppoint/GetUserSetting', {
        ConsulName: _this.ruleForm.ConsulName,
        StudentName: _this.ruleForm.StudentName,
        State: _this.ruleForm.State,
        pageIndex: _this.pageIndex,
        pageSize: 10,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.AppointList = res.Data;
          _this.IsLoading = false;
          this.Counts = Number(res.Counts);
        } else {
          this.$message.error(res.Message);
        }
      });
    },
    onClearData() {
      this.riRateContent = [];
      this.from.StudentVal = '';
    },
    DeleteRow(item) {
      if (item.State == 1) {
        this.Global.request_info('不能删除已完成评估的记录');
      } else {
        let _this = this;
        this.$Http_Post('ReportCriData/DeleteRPSetting', {
          SettingID: item.SettingID,
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            _this.Init();
            this.Global.request_successful(res.Message);
          } else {
            this.Global.request_failure(res.Message);
          }
        });
      }
    },
    PeopleSetting() {
      this.WPPdialogVisible3 = true;
      this.riRateContent = [];
      this.regionTypes = [];
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.dialogHeight =
        (document.documentElement.clientHeight * 0.65).toString() + 'px';
    })
  },
};
</script>
<style>
.bg-purple-right table td {
  padding-left: 0px;
}

.app-parent {
  height: 100%;
  overflow: auto;
}

.app-block {
  padding: 10px;
  line-height: 25px;
  background-color: #ebf5ff;
  border-radius: 5px;
  margin-bottom: 5px;
}

.app-paper-res {
  margin-left: 10px;
}

.app-paper-detail {
  color: blue;
  text-decoration: underline;
  margin-left: 10px;
  cursor: pointer;
}

.fromcss {
  padding: 30px 0px 0px 0px;
}

.AppointmentList .demo-form-inline {
  padding: 24px;
}

.el-drawer__header {
  font-size: 20px;
  margin-bottom: 1px;
}

.filein {
  background-color: rgba(239.99999999999997,
      239.99999999999997,
      239.99999999999997,
      1);
}

.filein-top {
  width: 100%;
  background-color: #fff;
}

.filein-button {
  min-height: 555px;
  margin-top: 20px;
  background-color: #fff;
}

.AppointmentList .el-dialog {
  background-color: rgba(239.99999999999997,
      239.99999999999997,
      239.99999999999997,
      1);
}

.AppointmentList .el-dialog__header {
  padding: 0px !important;
}

.AppointmentList .el-dialog__body {
  padding-top: 14px;
  background-color: #fff;
}

.filein-top .filein-top-p1 {
  font-size: 20px;
  font-weight: 700;
  padding: 16px;
}

.filein-top .filein-top-p2 {
  font-size: 18px;
  padding: 16px;
}

.filein-top .filein-top-p2 span {
  font-size: 16px;
  color: rgba(141, 141, 141, 1);
}

.filein-top i {
  display: inline-block;
  background-color: rgba(29, 154, 255, 1);
  font-size: 14px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  font-weight: 111;
  padding: 1px;
  padding-left: 6px;
  padding-right: 6px;
}

.filein-top em {
  display: inline-block;
  background-color: rgba(21, 191, 109, 1);
  font-size: 14px;
  height: 26px;
  width: 60px;
  line-height: 26px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  font-weight: 111;
}

.filein-top .el-button {
  margin-right: 16px;
  position: absolute;
  right: 50px;
  top: 50px;
}

.filein-button h2 {
  font-size: 24px;
  font-weight: 700;
  padding: 5px 16px;
}

.filein-button h3 {
  font-size: 18px;
  font-weight: 700;
  padding: 5px 16px;
  padding-left: 24px;
  padding-top: 0px;
}

.AppointmentList .el-textarea__inner {
  width: 600px;
}

.AppointmentList .el-input {
  width: 200px;
}

.AppointmentList .el-radio {
  margin-left: 0px;
}

.AppointmentList .el-form--inline .el-form-item {
  border: 1px solid rgba(245, 247, 250, 1);
  width: calc(50 - 2px);
  margin-right: 0px;
}

.AppointmentList .el-dialog__body .el-form-item__label {
  background-color: rgba(245, 247, 250, 1);
  text-align: left;
  text-indent: 24px;
  height: 100%;
}

.AppointmentList .el-dialog__body .el-form--inline .el-form-item {
  width: calc(50% - 20px);
}

.AppointmentList .el-dialog__body .hiucs {
  width: 680px !important;
}

.hiucs .el-form-item__label {
  height: 54px !important;
  line-height: 54px;
}

.AppointmentList .el-dialog__body .el-textarea__inner {
  margin-left: 0px !important;
}

.AppointmentList .qxs1 .el-input__inner {
  border: none;
  border-bottom: 1px solid rgb(182, 182, 182);
  border-radius: 0px;
}

.AppointmentList .bagtit .el-form-item {
  border: none !important;
}

.AppointmentList .el-dialog__body .bvds {
  width: calc(50% - 40px) !important;
}

.hiucs2 .el-form-item__label {
  height: 106px !important;
  line-height: 106px;
}

.AppointmentList .el-dialog__body .svccsc {
  width: 840px !important;
}

.svccsc .el-form-item__label {
  height: 54px !important;
  line-height: 54px;
}

.AppointmentList .el-dialog__body .svcsscsc {
  width: 860px !important;
}

.svcsscsc .el-form-item__label {
  height: 54px !important;
  line-height: 54px;
}

.AppointmentList .el-dialog__body .el-form-item__content span {
  margin-left: 5px;
}

.AppointmentList .boxs {
  background-color: #fff;
  margin-bottom: 15px;
}

.AppointmentList .boxs button {
  float: right;
  margin-right: 20px;
}

.AppointmentList .boxs2 {
  background-color: #fff;
  height: 620px;
}

.AppointmentList .block {
  float: right;
}

.el-drawer__body tbody td {
  border: none;
}

.AppointmentList .el-descriptions-item__label {
  color: rgba(40, 40, 40, 1);
  font-size: 16px;
}

.AppointmentList .el-descriptions-item__content {
  color: rgba(141, 141, 141, 1);
}

.AppointmentList .el-drawer__open .el-drawer.rtl {
  width: 40% !important;
}

#el-drawer__title {
  color: #000;
  font-weight: 700;
}

.AppointmentList .ClientConsulting_right_ul {
  margin-left: -3px;
  width: 100%;
}

.AppointmentList .ClientConsulting_right_ul>li {
  background-color: #031924;
  float: left;
  margin-top: 10px;
  width: calc(100% / 7 - 10px);
}

.AppointmentList .ClientConsulting_right_ul>li ul {
  margin-left: 10px;
}

.AppointmentList .ClientConsulting_right_ul>li ul li {
  margin-top: 10px;
  height: 60px;
  width: 100%;
  background-color: #0a3554;
  margin-left: 4px;
  line-height: 60px;
  text-align: center;
  font-size: 18px;
  color: #6ebec2;
  position: relative;
}

.AppointmentList .ClientConsulting_right_ul>li ul li p {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: rgba(11, 131, 138, 1);
  color: rgba(64, 245, 255, 1);
  display: none;
}

.AppointmentList .ClientConsulting_right_ul>li ul li i {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: rgba(11, 131, 138, 1);
  color: rgba(64, 245, 255, 1);
}

.AppointmentList .ClientConsulting_right_ul>li ul li i:hover span {
  display: block;
}

.AppointmentList .ClientConsulting_right_ul>li ul li i span {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: rgba(11, 131, 138, 1);
  color: rgba(64, 245, 255, 1);
  position: absolute;
  top: 0px;
  left: 0px;
  display: none;
}

.AppointmentList .ClientConsulting_right_ul>li ul li:hover p {
  display: block;
}

.AppointmentList .ClientConsulting_right_top {
  margin-left: 10px;
}

.AppointmentList .ClientConsulting_right_top li {
  background-color: rgb(10 53 84);
  width: calc(100% / 7 - 10px);
  float: left;
  height: 56px;
  margin-top: 20px;
  border: 1px solid #00e6ff;
  margin-left: -1px;
  color: #6ebec2;
  text-align: center;
}

.AppointmentList .ClientConsulting_right_top li p {
  height: 20px;
  margin-top: 6px;
}

.AppointmentList .ClientConsulting_right_ul {
  margin-left: 0px;
}

.AppointmentList .el-table__column-filter-trigger i {
  color: #fff;
  font-size: 16px;
  margin-left: 10px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.demonstration {
  display: block;
  color: #8492a6;
  font-size: 12px;
  margin-bottom: 20px;
}

.el-radio__inner {
  border: 1px solid #55585e;
}

.AppointmentList .el-table--enable-row-transition .el-table__body td {
  text-align: center;
}

/*WPF修改*/
.bg-purple-left {
  float: left;
  width: 30%;
  height: 100%;
  background-color: #ebf5ff;
  height: calc(100% - 50px);
}

.bg-purple-right {
  position: relative;
  float: right;
  width: 69%;
  height: calc(100% - 50px);
  background-color: #ebf5ff;
  overflow: auto;
}

.buttons {
  width: calc(100% - 40px);
  text-align: center;
  position: absolute;
  bottom: 20px;
}

.bg-purple-option {
  width: 100%;
  height: 50px;
  margin-top: 5px;
  text-align: center;
}

.bg-purple-content {
  width: 100%;
  height: calc(100% - 60px);
}
</style>
